// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Comparables p {
  margin-bottom: 0;
}
.Comparables__Button {
  height: 3rem;
}
.Comparables__SpinnerWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 50vh;
}
.Comparables__List {
  margin-top: 4%;
}
.Comparables__List .row:nth-of-type(even) {
  background: #eee;
}
.Comparables__MapAndTableContainer {
  display: flex;
  flex-wrap: wrap;
  transition: all 1s;
  padding-bottom: 1rem;
}
.Comparables__MapAndTableContainer--NoMap .Comparables__MapSection {
  width: 0;
  height: 0;
}
.Comparables__ListSection {
  flex: 1 1 60%;
  margin-bottom: 0.5rem;
}
.Comparables__MapSection {
  height: 100%;
  margin-left: 0.25rem;
  border-radius: 5px;
  flex: 1 1 calc(40% - 4px);
}
.Comparables__MapToggleRow {
  align-items: center;
}
.Comparables__MapToggleLabel {
  margin-bottom: 0;
}

.warning {
  margin: 2%;
}

@media screen and (max-width: 1024px) {
  .Comparables__List {
    padding: 0 !important;
  }
  .Comparables__ListSection {
    flex: 1 1 100%;
  }
}`, "",{"version":3,"sources":["webpack://./libs/features/feat-comparables/src/lib/comparables/comparables.component.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;AAAJ;AAGE;EACE,YAAA;AADJ;AAIE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAFJ;AAKE;EACE,cAAA;AAHJ;AAKI;EACE,gBAAA;AAHN;AAOE;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;AALJ;AAQM;EACE,QAAA;EACA,SAAA;AANR;AAWE;EACE,aAAA;EACA,qBAAA;AATJ;AAYE;EACE,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;AAVJ;AAaE;EACE,mBAAA;AAXJ;AAcE;EACE,gBAAA;AAZJ;;AAgBA;EACE,UAAA;AAbF;;AAgBA;EACE;IACE,qBAAA;EAbF;EAgBA;IACE,cAAA;EAdF;AACF","sourcesContent":[".Comparables {\n  p {\n    margin-bottom: 0;\n  }\n\n  &__Button {\n    height: 3rem;\n  }\n\n  &__SpinnerWrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    min-height: 50vh;\n  }\n\n  &__List {\n    margin-top: 4%;\n\n    .row:nth-of-type(even) {\n      background: #eee;\n    }\n  }\n\n  &__MapAndTableContainer {\n    display: flex;\n    flex-wrap: wrap;\n    transition: all 1s;\n    padding-bottom: 1rem;\n\n    &--NoMap {\n      .Comparables__MapSection {\n        width: 0;\n        height: 0;\n      }\n    }\n  }\n\n  &__ListSection {\n    flex: 1 1 60%;\n    margin-bottom: 0.5rem;\n  }\n\n  &__MapSection {\n    height: 100%;\n    margin-left: 0.25rem;\n    border-radius: 5px;\n    flex: 1 1 calc(40% - 4px);\n  }\n\n  &__MapToggleRow {\n    align-items: center;\n  }\n\n  &__MapToggleLabel {\n    margin-bottom: 0;\n  }\n}\n\n.warning {\n  margin: 2%;\n}\n\n@media screen and (max-width: 1024px) {\n  .Comparables__List {\n    padding: 0 !important;\n  }\n\n  .Comparables__ListSection {\n    flex: 1 1 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
